import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
} from 'recharts';
import { fetchStatsByType } from 'Store/stats/actions';
import { initializeList, updateStatsListSearch } from 'Store/lists/actions';
import * as reducers from 'Store/reducers';

import Error from 'Containers/Error';
import Loading from 'Components/Loading';
import ContentFrame from 'Components/ContentFrame';

import { ROUTES } from '../../settings/route-strings';

class GraphsStatsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.graphDataMap = {};
    let date = new Date();
    for (let i = 0; i < 31; i++) {
      const dateString = date.toISOString().split('T')[0];
      this.graphDataMap[dateString] = 0;
      date = new Date(date.setDate(date.getDate() - 1));
    }

    this.state = {
      requestedStats: false,
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats() {
    if (!this.state.requestedStats) {
      this.setState({ requestedStats: true }, () => {
        this.props.initializeList('educators_stats', 'educators_stats');
        this.props.fetchStatsByType('educators');
      });
    }
  }

  render() {
    const { activeUser, pageError, list } = this.props;
    if (pageError) return <Error type="apiLoadError" code="500" />;
    if (!activeUser || !list || Object.keys(list.data).length === 0)
      return <Loading />;

    const { data } = list;
    const dataList = Object.keys(data).map(key => data[key]);
    const allStartDates = dataList.map(
      ({ licenses }) =>
        licenses && licenses[0] && licenses[0].start_time.split('T')[0]
    );

    allStartDates.forEach(dateString => {
      if (typeof this.graphDataMap[dateString] === 'number') {
        this.graphDataMap[dateString] += 1;
      }
    });

    const graphData = Object.keys(this.graphDataMap)
      .map(key => ({
        name: key,
        numSignups: this.graphDataMap[key],
      }))
      .reverse();

    return (
      <ContentFrame>
        <h2>License Start Dates: Past 31 Days</h2>
        <LineChart data={graphData} width={800} height={250}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="numSignups" stroke="#82ca9d" />
        </LineChart>
      </ContentFrame>
    );
  }
}

GraphsStatsPage.propTypes = {
  activeUser: PropTypes.object,
  pageError: PropTypes.object,
  list: PropTypes.object,
  initializeList: PropTypes.func.isRequired,
  fetchStatsByType: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const type = 'educators';
  return {
    activeUser: reducers.getActiveUser(state),
    pageError: reducers.getPageError(state, ROUTES.ADMIN_V2_STATS_EDUCATORS),
    isFetchingStats: reducers.isFetchingStats(state, 'statsByType'),
    list: reducers.getStatsListByType(state, type),
  };
};

export default connect(mapStateToProps, {
  fetchStatsByType,
  initializeList,
  updateStatsListSearch,
})(GraphsStatsPage);
